import GenericPaginatedUploadMixin from './generic-paginated-upload-mixin';

const countErrors = {};

const UrlLoaderUploadMixin = {
  mixins: [GenericPaginatedUploadMixin],

  _buildFormData(formData, file) {
    formData.append('url', file.url);
    formData.append('name', file.filename || file.title);
    if (file.foreignUserId) {
      formData.append('foreign_user_id', file.foreignUserId);
    }
  },

  saveErrors(service, responseCode) {
    if (responseCode > 399 && responseCode < 600) {
      if (responseCode === 400) {
        countErrors.tooManyRequests = service;
      }

      countErrors[service] = countErrors[service] && countErrors[service] > 0 ? countErrors[service] + 1 : 1;
    }
  },

  reachedErrorLimit(service) {
    return countErrors[service] > 100;
  },

  makesTooManyRequests(service) {
    return countErrors.tooManyRequests === service;
  },
};

export default UrlLoaderUploadMixin;
